import { IMCellIndex } from './typings';

let _value = 1;

export const UN_REACHABLE_CELL = {
  get rowIndex(): number {
    _value--;
    return _value - 1;
  },
  get colIndex(): number {
    _value--;
    return _value - 1;
  }
};

export const DEFAULT_ADD_CELL = {
  height: 0,
  offset: -1,
  page_number: 0,
  text: '',
  width: 0,
  x: 0,
  y: 0
};

export function convertActivatedToEditing(pair: [IMCellIndex, IMCellIndex]): IMCellIndex {
  const pre = pair[0];
  const cur = pair[1];
  if (pre.rowIndex === cur.rowIndex && pre.colIndex === cur.colIndex) {
    return {
      rowIndex: cur.rowIndex,
      colIndex: cur.colIndex
    };
  } else {
    return {
      ...UN_REACHABLE_CELL
    };
  }
}

export function getCellIndexFromEle(e: HTMLElement): IMCellIndex {
  return {
    rowIndex: Number(e.getAttribute('data-row-index')),
    colIndex: Number(e.getAttribute('data-col-index'))
  };
}

export function isIE(): boolean {
  // tslint:disable-next-line:no-any
  if (!!(window as any).ActiveXObject || 'ActiveXObject' in window) {
    return true;
  } else {
    return false;
  }
}
